// extracted by mini-css-extract-plugin
module.exports = {"container":"Alert_container_2WT9k"};